<!-- STATS -->
<div class="f-row stats owl-carousel owl-theme {{ color }}">
    <div *ngFor="let cd of carouselData; let i = index;" class="item" [innerHTML]="cd.svg"></div>
</div>
